import { ParameterTypeValueActionTypes, ParameterTypeValueTypes } from "./parameterTypeValueTypes";

export function changeParameterTypeValue(
	data: boolean,
	isError: boolean,
	errorMessages: string[] | null,
): ParameterTypeValueActionTypes {
	return {
		type: ParameterTypeValueTypes.UPDATE_CHANGE_FORM,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerParameterTypeValue(): ParameterTypeValueActionTypes {
	return {
		type: ParameterTypeValueTypes.RESET_CHANGE_FORM,
	};
}
